import ReactStrapTable from 'components/reactStrapTable';
import React, { useEffect, useState } from 'react'
import EditIcon from 'assets/icon/icon-icon-options-edit.svg';
import ConfigIcon from "assets/icon/config-setting-icon.svg";
import ConfigIconHover from "assets/icon/config-setting-icon-hover.svg";
import EditHoverIcon from 'assets/icon/icon-icon-options-edit_hover.svg';
import HoverImage from 'react-hover-image/build';
import { Button, ButtonGroup, Col, FormGroup, Input, InputGroup, InputGroupText, Label, Row } from 'reactstrap';
import { dateFormate, currencyFormat, cellRendererCheck } from 'utils/columns';
import CancleIcon from 'assets/icon/icon-icon-options-not-eligible.svg';
import Calendar from 'assets/icon/calendar-icon.svg';
import SaveIcon from 'assets/icon/icon-icon-options-order-complete.svg';
import CellEditRender from 'components/reactStrapTable/components/CellEditRender';
import CancleHoverIcon from 'assets/icon/icon-icon-options-not-eligible-hover.svg';
import SaveHoverIcon from 'assets/icon/icon-icon-options-order-complete-hover.svg';
import { Field, Formik } from 'formik';
import ReactSelect from 'react-select';
import FormikDatePicker from 'components/common/Fields/FormikDatePicker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleUp } from "@fortawesome/free-solid-svg-icons";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import Drawer from 'components/Drawer';
import FormikSelectField from 'components/common/Fields/FormikSelectField';
import { Option, LimitedChipsContainer } from 'components/Options';
import useAxios from 'hooks/useAxios';
import useContextService from 'hooks/useContextService';
import { cloneDeep } from 'lodash';
import reseticon from "assets/icon/reset.svg";
import search from "assets/icon/search.svg";




let hasDatePopupOpen = false;

let tableDataBackup = [
    {
        chainPharmacy:"123445",
        pharmacy:"123445",
        npi:"123445",
        ncpdPandNABP:"123445",
        pharmacyAddress:"123445",
        pharmacyLiveDate:"123445",
        pharmacyTerminationDate:"123445",
        claimsProcessDate:"123445",

    }
];
let rowForEdit = {};
let updatedFields = {};
let coveredEntityError = "";
let accumulationError = "Accumulator is a required field";

let coveredEntitiesData = [];
let accumulationData = [];
let hospitalData=[];
let drugFlag = "DrugCatalog";
const SearchContainer = (props) => {
    const API = useAxios();

    const {
        states: { drugCatalog },
        setStates,
        resetStates,
      } = useContextService();
    const { coveredEntity,searchTerms,accumulations } =drugCatalog
    let {
      coveredEntityIDs,
      coveredEntityID,
      accumulationIDs,
      hospitalDD
    } = searchTerms;
      const updateStates = (drugCatalog) => {
        setStates("drugCatalog", drugCatalog);
      };
      const { orgId, onReset,onSearch, reset } = props;

    
    const [tableData, setTableData] = useState(tableDataBackup);
    const [data, setData] = useState(tableDataBackup);
    const [showDetails,setShowDetails]=useState(true)
    const [collapseSider, setcollapseSider] = useState(false);
    const [collIcon, setCollIcon] = useState(faAngleUp);
    const [activeButton, setActiveButton] = useState("All");
    const [hasACCSelected, setACCSelected] = useState(true);
    const [hasCESelected, setCESelected] = useState(true);
    const [isSubmited, serIsSubmitted] = useState(false);
    const [selectedCEOption, setCEOptionSelected] = useState({
        optionCESelected: "-1",
      });
    const [selectedACCOption, setOptionACCSelected] = useState({
        optionACCSelected: "-1",
      });
      const [hospitalErr, setHospitalErr] = useState("");
      const [selectedHospital,setHospitalselected]=useState({})
      const[accumualator,setAccumualator]=useState("");

      const [loading, setLoading] = useState(false);

    const toggleSider = () => {
        setcollapseSider(!collapseSider);
        if (!collapseSider) {
            setCollIcon(faAngleDown);
        }
        else {
            setCollIcon(faAngleUp);
        }
    }
    const handelAddCrosswalk=async()=>{
        await addCrosswalk()
    }

   
    const renderEditButton = () => {
        // if (hasPermission('EDT'))
            return <Button
                className='text-primary p-0 text-decoration-none'
                color='link'
                onClick={() => ""}
                title='Edit Covered Entity'

            >
                <HoverImage src={EditIcon}
                    hoverSrc={EditHoverIcon}
                    alt='' />
            </Button>
    }
    const cellRenderEdit = (rowData) => {
      if (hasPermission('ED'))
        if (rowData.isEdit) {
            return (
                <div className='d-flex align-items-center'>
                    <Button
                        className='text-primary p-0 text-decoration-none'
                        color='link'
                        onClick={savePanelUpdateRow}
                    >
                        <HoverImage
                            key='SaveIcon'
                            src={SaveIcon}
                            hoverSrc={SaveHoverIcon}
                            alt=''
                        />
                    </Button>
                    <Button
                        className='text-primary p-0 text-decoration-none'
                        color='link'
                        onClick={() => editRow(rowData, false)}
                    >
                        <HoverImage
                            key='CancelIcon'
                            src={CancleIcon}
                            hoverSrc={CancleHoverIcon}
                            alt=''
                        />
                    </Button>
                </div>
            );
        } else {

            return (
                <div className='d-flex align-items-center'>
                    {renderEditLButton1(rowData)}

                </div>
            );
        }
    };
    const renderEditLButton1 = (rowData) => {
        // if (hasPermission('EPLS'))
            return <Button
                className='text-primary p-0 text-decoration-none'
                color='link'

                onClick={() => editRow(rowData)}
                title='Edit'


            >
                <HoverImage src={EditIcon}
                    hoverSrc={EditHoverIcon}
                    alt='' />
            </Button>
    }
    const editRow = (rowData, isEdit = true) => {

        let tempData = [...data];
        tempData = tempData.map((row) => {
            row.isEdit = false;
            if (row.ceServiceLocationID === rowData?.ceServiceLocationID && isEdit) {
                row.isEdit = isEdit;
                rowForEdit = row;
            }
            return row;
        });
        // setTouched('');
        // setSelectedStatus('');
        updatedFields = {};
        //  tableDataBackup = tempData;
        setData(tempData);
    };
    const savePanelUpdateRow = async () => {
console.log("krishna")
    };
    const updateRowValue = (value, col) => {

        const tempRow = { ...rowForEdit };
        tempRow[col] = value;
        rowForEdit = tempRow;
    };
    const formatter = (row, col, formatterType, alwaysEditableCheckbox) => {

        return (
            <CellEditRender
                row={row}
                col={col}
                formatterType={formatterType}
                onChange={updateRowValue}
                alwaysEditableCheckbox={alwaysEditableCheckbox}
            />
        );
    };

    const handelAdd=()=>{
        setShowDetails(false)
    }
    const handelCancel=()=>{
        setShowDetails(true)
    }
    useEffect(()=>{

    },[showDetails])
    const handleMouseLeave = () => {
        hasDatePopupOpen = false;
    };

    const handleDateClick = (id) => {

        if (hasDatePopupOpen) {
            hasDatePopupOpen = false;
            return;
        }
        const calendarButton = document.getElementById(id);
        if (calendarButton) {
            calendarButton.click();
            hasDatePopupOpen = true;
        }
    };

    const handleButtonClick = (button) => {
      setActiveButton(button);
    };
    useEffect(() => {
        setCESelected(true);
        setACCSelected(true);   
        coveredEntitiesData = [];
        accumulationData = [];
        hospitalData=[];
        coveredEntityError = ""
        drugCatalog.searchTerms.coveredEntityIDs = {};
        drugCatalog.searchTerms.accumulationIDs = {};
        drugCatalog.accumulations = [];
        updateStates(drugCatalog);
        setCEOptionSelected({optionCESelected:'-1'});
        setOptionACCSelected({optionACCSelected:'-1'});
        setHospitalselected('');
        // setOrderStatusSelected('');
        // setPONumber('');
        setHospitalErr("")
        fetchCoveredEntities();
        serIsSubmitted(false);


      },[orgId,reset]);
    //   useEffect(() => {
    //     fetchHospital();
    // }, []);
    const fetchCoveredEntities = async () => {
      debugger
      if (typeof orgId !== "undefined" && orgId !== null) {
          coveredEntitiesData = [];
          drugCatalog.searchTerms.coveredEntityIDs = [];
          updateStates(drugCatalog);

          let selectedOrgId = orgId.organizationID;

          setLoading(false);
          try {
              const { data } = await API.get(`SBConfig/coveredentity/list/${selectedOrgId}`, {
                  hasDefaultURL: true,
              });
              setLoading(false);
              if (data) {
                  for (var x in data) {
                      coveredEntitiesData.push({ "value": data[x].coveredEntityID, "label": data[x].coveredEntityName });
                  }
                  console.log(data, "Data");
                  drugCatalog.coveredEntities = data;

                  if (coveredEntitiesData.length == 1) {
                      var ceData = [];
                      ceData.push(coveredEntitiesData[0])
                      drugCatalog.searchTerms.coveredEntityIDs = ceData;
                      window.selectedCoveredEntittyId = ceData;
                  }
                  if(window.selectedCoveredEntittyId.length > 0){
                    drugCatalog.searchTerms.coveredEntityIDs = window.selectedCoveredEntittyId;
                  }
                  

                  updateStates(drugCatalog);
                  if (drugCatalog.searchTerms.coveredEntityIDs) {

                      var ceSelected = [];
                      ceSelected.optionCESelected = [];
                      for (var x in drugCatalog.searchTerms
                          .coveredEntityIDs) {
                          ceSelected.optionCESelected.push(
                              drugCatalog.searchTerms.coveredEntityIDs[x]
                          );
                      }
                      setCEOptionSelected(ceSelected);
                      let ceIds = drugCatalog.searchTerms.coveredEntityIDs.map(item => item["value"]);
                      fetchAccumulatorName(ceIds);
                  }

              }
          }
          catch (err) {
              setLoading(false);
          }
      }

  };
  const handleCoverdEntityChange = (selectedces, setFieldValue, entity) => {
      let selected = [selectedces == null ? []: selectedces]
      if (selected) {
           coveredEntityError = "";
          window.selectedCoveredEntittyId = selected;
          window.selectedAccumulatorId = [];
          accumulationData = [];
          // setSelectedNdc('');
          drugCatalog.searchTerms.accumulationIDs = {};
          setCESelected(true);
          coveredEntityError = ""
          setCEOptionSelected({
              optionCESelected: selected.value
          });
       
          let val = selected.value;
          drugCatalog.coveredEntities = selected;
          //setFieldValue('coveredEntityIDs', selected);
          drugCatalog.searchTerms.coveredEntityIDs = selected;
          if (Array.isArray(drugCatalog.searchTerms.coveredEntityIDs)) {
              accumulationIDs = {};
              drugCatalog.searchTerms.accumulationIDs = {};
          }
          let ceIds = drugCatalog.searchTerms.coveredEntityIDs.map(item => item["value"]);
          //drugCatalog.searchTerms.coveredEntityIDs = ceIds;
          updateStates(drugCatalog);
          fetchAccumulatorName(ceIds);
          setOptionACCSelected({ optionACCSelected: '-1' });
      }
      else {
         // setFieldValue('coveredEntityIDs', {});
          accumulationData = [];
          drugCatalog.coveredEntities = [];
          drugCatalog.searchTerms.coveredEntityIDs = {};
          drugCatalog.searchTerms.accumulationIDs = {};
          setCESelected(false);
          setACCSelected(false);
      }
      updateStates(drugCatalog);
  };
  const fetchAccumulatorName = async (coveredEntityIDs) => {
    
      if (coveredEntityIDs !== undefined && coveredEntityIDs.length > 0) {
          try {
              accumulationData = [];
              const payload = [];
              payload.AccumulatorEntityList = [coveredEntityIDs[0]];
              let AccumulatorEntityList = [payload.AccumulatorEntityList]
              const result = await API.get(`SBConfig/coveredentity/acclist/${AccumulatorEntityList}`,
                  {
                      hasDefaultURL: true,
                  }
              );
              if (result) {
                  let accumulator = []
                  accumulator = result.data;
                  for (var x in accumulator) {
                      accumulationData.push({ "value": accumulator[x].accumulatorID, "label": accumulator[x].ceName });
                  }
                  
                  if (accumulationData.length == 1) {
                    handleAccumulatorname(accumulationData[0]);

                  } 
                  // else if (window.selectedAccumulatorId.length > 0) {
                  //   drugCatalog.searchTerms.accumulationIDs =
                  //     window.selectedAccumulatorId;
                  //     handleAccumulatorname(window.selectedAccumulatorId[0]);
                  // }
                  drugCatalog.accumulations = result.data;
                  updateStates(drugCatalog);
                  // if (accumulationIDs.length > 0) {
                  //     var accumulatorSelected = {};
                  //     accumulatorSelected.optionACCSelected = [];
                  //     for (var x in accumulationIDs) {
                  //         accumulatorSelected.optionACCSelected.push(accumulationIDs[x]);
                  //     }
                  //     setOptionACCSelected({ accumulatorSelected});
                  // }
              }
          } catch (error) {
              console.log(error.message);
          }
      }
  };
  const handleAccumulatorname = (selectedacs, setFieldValue, ac) => {
    let selected = [selectedacs == null ? [] : selectedacs]
       window.selectedAccumulatorId = selected;
      if (selected) {
          setACCSelected(true);
          setOptionACCSelected({
              optionACCSelected: selected
          })
          //   let val = selected.value;
          //   setFieldValue('accumulatorID', val);
          //   setFieldValue('accumulationIDs', selected);
          drugCatalog.searchTerms.accumulationIDs = selected;
          fetchHospital(selected);
          setAccumualator(selected[0].value);
      }
      else {
          setACCSelected(true);
          //   setFieldValue('accumulationIDs', {});
          accumulationData = [];
          drugCatalog.coveredEntities = [];
          drugCatalog.searchTerms.accumulationIDs = {};
          drugCatalog.searchTerms.coveredEntityIDs = {};
          setCESelected(false);
      }
      updateStates(drugCatalog);
  };
    const fetchHospital = async(selected)=>{
      hospitalData=[]
      try{
          const {data} = await API.get(`SBConfig/coveredentity/hospitallist/${selected[0].value}/${drugFlag}`,
              {
                  hasDefaultURL: true,
              }
          );
          if(data){
              for(var x in data){
                hospitalData.push({id:data[x].accountGroupID,description:data[x].accountGroupName})
              }
          }
      }
      catch{
// setLoading(false);
      }
  }

    // const fetchHospital = async (accumulationIDs) => {
    //   debugger;
    //   if (accumulationIDs !== undefined && accumulationIDs.length > 0) {
    //     try {
    //       const payload = [];
    //             payload.AccumulatorList = accumulationIDs;
    //             let AccumulatorList = [payload.AccumulatorList]
    //       // let list=[];
    //       // list.AccumulationIDs = accumulationIDs;
    //       const  {data}  = await API.get(
    //         `SBConfig/CoveredEntity/hospitallist/${AccumulatorList}`,
    //         {
    //           hasDefaultURL: true,
    //         }
    //       );
    //       console.log(data, "Hospital Type Data");
    //       if (data) {
    //         for (var x in data) {
    //           hospitalData.push({
    //             id: data[x].accountGroupID,
    //             description: data[x].accountGroupName,
    //           });
    //           console.log(hospitalData, "Data from Hospitals");
    //         }
    //         if (hospitalDD) {
    //           drugCatalog.searchTerms.hospitalDD = hospitalDD;
    //           updateStates(drugCatalog);
    //         }
    //         setHospitals(data);
    //       } else {
    //         setHospitals([]);
    //       }
    //     } catch (err) {}
    //   }
    // };
    const handleHospitalChange = (e, setFieldValue) => {
      if (e){
        setHospitalErr("")
        const { value } = e.target;
        //setFieldValue('hospitalDD', value);
        setHospitalselected(value)
        drugCatalog.searchTerms.hospitalDD = value;
        updateStates(drugCatalog);
      }
      else{
       // setFieldValue('hospitalDD', {});
        drugCatalog.coveredEntities = [];
            drugCatalog.searchTerms.accumulationIDs = {};
        drugCatalog.searchTerms.hospitalDD = {};
        setACCSelected(true);

      }
        // console.log(value,"Account")
    };

    const handleSubmit = async (val, actions) => {
      debugger
       
        serIsSubmitted(true);
        const { setSubmitting } = actions;
        let acIDs = [];
        let ceIDs = [];
        //let phIDs = [];
    
        // if (searchTerms.coveredEntityIDs.length > 0) {
        //   val.coveredEntityIDs = searchTerms.coveredEntityIDs;
        //   setCESelected(true);
        // }
        // if (searchTerms.accumulationIDs.length > 0) {
        //     val.accumulationIDs = searchTerms.accumulationIDs;
        //     setACCSelected(true);
        //   }
    
        for (var x in searchTerms.accumulationIDs) {
          var rw = searchTerms.accumulationIDs[x];
          acIDs.push(rw.value);
        }
        for (var x in searchTerms.coveredEntityIDs) {
          var rw = searchTerms.coveredEntityIDs[x];
          ceIDs.push(rw.value);
        }
        // for (var x in val.pharmacyIds) {
        //   var rw = val.pharmacyIds[x];
        //   phIDs.push(rw.value);
        // }
        if(selectedHospital.length==0){
          setHospitalErr("Hospital Name is a required field")
      }
      if (selectedHospital.length > 0) {
        setHospitalErr("")
      }
      if (ceIDs.length == 0) {
        setCESelected(false);
        coveredEntityError = "Covered Entity is a required field"

        // return setSubmitting(false);
      }
      if (acIDs.length == 0) {
        setACCSelected(false);
    }
    if (selectedHospital != "" && selectedHospital != undefined && accumualator != "" && accumualator != undefined){
        const values = cloneDeep(val);
    
        // if (ceIDs > [0]) values.coveredEntityIDs = val.coveredEntityIDs;
        // if (ceIDs > [0]) values.CoveredEntityIDs = ceIDs;
        if (acIDs > [0]) values.accumulationIDs = acIDs;
        if (hospitalDD) values.hospitalDD = hospitalDD;

        
        if (selectedHospital) {
          values.hospitalDD = selectedHospital;
        }
        else {
            values.hospitalDD = 0;
        }
        values.hospitalDD = hospitalDD;
        drugCatalog.search.currentPage = 1;
        updateStates(drugCatalog);
        await onSearch(values);
        setSubmitting(false);
      }
      };
      console.log(selectedHospital.length,"selectedhospital",hospitalErr)
      const handleReset = async () => {
        serIsSubmitted(false);
        setCESelected(true);
        setACCSelected(true);
        setHospitalselected("")
    coveredEntityError = ""
        setHospitalErr("")
        // setOrderStatusSelected("");
        // setPONumber('');
        accumulationData=[];
        hospitalData=[];
        window.selectedCoveredEntittyId = [];
        window.selectedAccumulatorId = [];
     
        setCEOptionSelected({ optionCESelected: "-1" });
        setOptionACCSelected({ optionACCSelected: "-1" });
        drugCatalog.searchTerms.coveredEntityIDs = {};
        drugCatalog.searchTerms.accumulationIDs = {};
        updateStates(drugCatalog);
        resetStates("drugCatalog");
         await onReset();

    }
  return (
    <div>
      <Formik
        initialValues={searchTerms}
        onSubmit={handleSubmit}
        // validationSchema={validationSchema}
         enableReinitialize={true}
        children={(props) => {
          const {
            isSubmitting,
            handleSubmit,
            resetForm,
            setFieldValue,
            errors,
            touched,
          } = props;
          return (
            <div>
               <h5 className="f-16 text-primary font-weight-700">
              Search Drug Catalog
            </h5>
              <div>
                <Row sm={5} className="d-flex" style={{}}>
                  <Col md={3} lg={3} sm={6} xs={6}>
                    {" "}
                    <FormGroup>
                      <Label for="coveredentity">Covered Entity</Label>
                      <ReactSelect
                        name="coveredentity"
                        id="coveredentity"
                        options={coveredEntitiesData}
                        // isMulti
                       closeMenuOnSelect={true}
                       hideSelectedOptions={false}
                        optionSelected={true}
                        //isClearable={true}
                        components={{
                          Option,
                        }}
                        isSearchable="true"
                        onChange={(value, cp) =>
                          handleCoverdEntityChange(value, setFieldValue, cp)
                        }
                        value={selectedCEOption.optionCESelected}
                        className="claim_info required"
                        maxMenuHeight={220}
                        styles={{
                          menu: (provided) => ({
                            ...provided,
                            zIndex: 99,
                          }),
                          option: (provided) => ({
                                      ...provided,
                                      display: "flex",
                                      alignItems: "flex-start",
                                    }),
                        }}
                      />
                      {coveredEntityError != "" ? (
                        <div className="text-danger f-12 position-absolute">
                          {coveredEntityError}
                        </div>
                      ) : ""}
                    </FormGroup>
                  </Col>
                  <Col md={3} lg={3} sm={6} xs={6}>
                    {" "}
                    <FormGroup>
                      <Label for="accumulator">Accumulator</Label>
                      <ReactSelect
                        name="accumulator"
                        id="accumulator"
                        options={accumulationData}
                        // isMulti'
                        isDisabled = {accumulationData.length ==1}
                        closeMenuOnSelect={true}
                        hideSelectedOptions={false}
                        optionSelected={true}
                        isClearable={true}
                        components={{
                          Option,
                        }}
                        // isSearchable="true"
                        onChange={(value, ac) =>
                          handleAccumulatorname(value, setFieldValue, ac)
                        }
                        value={selectedACCOption.optionACCSelected}
                        className="claim_info required"
                        maxMenuHeight={220}
                        styles={{
                          menu: (provided) => ({
                            ...provided,
                            zIndex: 99,
                          }),
                          option: (provided) => ({
                                      ...provided,
                                      display: "flex",
                                      alignItems: "flex-start",
                                    }),
                        }}
                      />
                      {(!hasACCSelected && isSubmited) ||
                      (hasCESelected &&
                        isSubmited &&
                        selectedACCOption.optionACCSelected == "-1") ? (
                        <div className="text-danger f-12 position-absolute">
                          {accumulationError}
                        </div>
                      ) : null}
                    </FormGroup>
                  </Col>
                  <Col md={3} lg={3} sm={6} xs={6}>
                    {" "}
                    <FormGroup>
                      <Label for="hospitalname">Hospital Name </Label>
                      <Field
                        id="hospitalname"
                        name="hospitalname"
                        className="required"
                        type="select"
                        placeholder="Select Hospital Name "
                        autoComplete="off"
                        options={hospitalData}
                        closeMenuOnSelect={true}
                        hideSelectedOptions={false}
                        optionSelected={true}
                        component={FormikSelectField}
                        onChange={(e) => handleHospitalChange(e,setFieldValue)}
                        defaultoption="--Select--"
                        keys={{
                          id: "id",
                          label: "description",
                        }}
                      />
                      {hospitalErr && (
                        <div className="text-danger font-size-12">
                          {hospitalErr}
                        </div>
                      )}
                    </FormGroup>
                  </Col>
                </Row>
              </div>
              <div hidden={""}>
                <Row
                  style={{
                    justifyContent: "flex-end",
                    // marginRight: "10px",
                  }}
                >
                  <Col md="auto" className="">
                    <Label>{""}</Label>
                    <Button
                      // hidden={isAddPermission}
                      // disabled={isSubmitting}
                      color="primary"
                      className="search ms-3"
                      onClick={handleSubmit}

                      // disabled={!coveredEntityid}
                      // hidden={!hasPermission("ADD")}
                    >
                      <span className="right_5">
                    <img src={search} alt="" />
                  </span>{" "}
                      Search
                    </Button>
                    <Button
                      // hidden={isAddPermission}
                      // disabled={isSubmitting}
                      color="primary"
                      className="reset"
                      onClick={handleReset}

                      // disabled={!coveredEntityid}
                      // hidden={!hasPermission("ADD")}
                    >
                      <span className="right_5">
                    <img src={reseticon} alt="" />
                  </span>{" "}
                      Reset
                    </Button>
                  </Col>
                </Row>
              </div>
            </div>
          );
        }}
      ></Formik>
      {/* <div className="py-2 text-center">
                            <span style={{ fontSize: "27px", cursor: "pointer", }} onClick={toggleSider}>
                                <FontAwesomeIcon icon={collIcon} className="fa-fw" />
                            </span>
                        </div> */}
    </div>
  );
}

export default SearchContainer
